import {
  Modal,
  NewButton,
  NewButtonVariant,
  Radio,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { exportAnnotatedDocument } from "slices/dictionarySearch/actions/dictionarySearch";

const AnnotatedDocumentModal = ({ selectedTerms }) => {
  const dispatch = useDispatch();
  const options = [
    {
      text: "Use 'VisibleThread' as the comment author (default)",
      disabled: false,
    },
    {
      text: "Use the dictionary category as the comment author",
      disabled: false,
    },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0].text);
  const handleSubmit = () => {
    dispatch(
      exportAnnotatedDocument(selectedTerms, selectedOption === options[1].text)
    );
    dispatch(hideModal(modalTypes.ANNOTATED_DOCUMENT));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.ANNOTATED_DOCUMENT));
  };

  const modalBody = () => (
    <div className="annotated_document__body">
      Annotated Document Settings:
      <Radio
        options={options}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
    </div>
  );

  return (
    <Modal
      data-test="annotatedDocumentModal"
      className="fade-in"
      show
      backdrop
      centered
      onDismiss={handleCancel}
    >
      <Modal.Header>
        <b className="annotated_document__header">
          Download Annotated Document
        </b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="generate-document-button"
          variant={NewButtonVariant.l1}
          onClick={handleSubmit}
        >
          Generate Document
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AnnotatedDocumentModal;

AnnotatedDocumentModal.propTypes = {
  selectedTerms: PropTypes.arrayOf(PropTypes.string),
};
